import React, { memo, useCallback } from 'react';

import CicCommentTemplatePicker from 'app/shared/components/CicCommentTemplatePicker';
import { cicCommentTemplatesPropTypes } from 'app/shared/components/CicCommentTemplatePicker/CicCommentTemplatePicker.propTypes';
import { TextFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { NOTE_MAX_LENGTH } from './CicReasonFormModal.constants';
import { CicReasonFormModalTestIds } from './CicReasonFormModal.testIds';
import { noteCellInnerStyles } from './CicReasonFormModalNoteRow.styles';

const CicReasonFormModalNoteRow = ({
  feeTypeId,
  reason,
  notePath,
  noteValue,
  isLoading,
  errorMessage,
  onNoteChange,
  setInForm,
}) => {
  const onTemplateApply = useCallback(text => setInForm(notePath, text), [notePath, setInForm]);

  return (
    <div style={noteCellInnerStyles}>
      <CicCommentTemplatePicker
        commentTemplates={reason.commentTemplates}
        dataTestId={CicReasonFormModalTestIds.getTemplateSelectId(feeTypeId, reason.value)}
        dataTestIdInput={CicReasonFormModalTestIds.getTemplateSelectInputId(
          feeTypeId,
          reason.value,
        )}
        dataTestIdOption={CicReasonFormModalTestIds.getTemplateSelectOptionId(
          feeTypeId,
          reason.value,
        )}
        isDisabled={isLoading}
        name={`${notePath}.template`}
        reasonId={reason.value}
        onApply={onTemplateApply}
      />

      <TextFieldCDS
        multiline
        required
        data-testid={CicReasonFormModalTestIds.getNoteInputId(feeTypeId, reason.value)}
        disabled={isLoading}
        error={!!errorMessage}
        helperText={errorMessage}
        maxLength={NOTE_MAX_LENGTH}
        name={notePath}
        placeholder={`${NOTE_MAX_LENGTH} max character limit`}
        rows={3}
        value={noteValue || ''}
        variant="outlined"
        onChange={onNoteChange}
      />
    </div>
  );
};

CicReasonFormModalNoteRow.propTypes = {
  feeTypeId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  notePath: PropTypes.string.isRequired,
  reason: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    commentTemplates: cicCommentTemplatesPropTypes,
  }).isRequired,
  setInForm: PropTypes.func.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  noteValue: PropTypes.string,
};

export default memo(CicReasonFormModalNoteRow);
